import React from 'react';
import { selectIsTenant, useDomainStore } from '@/store/use-domain.store';
import CardDivider from '@/common/components/card-divider';
import { ResponsiveWrapper } from '@/common/components/wrapper';
import OtherDetail from './other-detail.component';
import OtherProducts from './other-products.conponent';
import ProductDetail from './product-detail.component';

interface Props {
  productDescription: string;
  productId: number;
  vendorId?: number;
}
const DESCRIPTION_COLLAPSE_THRESHOLD = 400;

const Body = ({ productDescription, productId, vendorId }: Props) => {
  const isTenant = useDomainStore(selectIsTenant);

  return (
    <>
      <CardDivider type="section" sectionClassName="lg:hidden" />

      <ResponsiveWrapper className="mt-8 px-4 md:px-0">
        <div className="overflow-y-auto lg:hidden">
          <ProductDetail
            description={productDescription}
            isCollapsable={
              productDescription.length > DESCRIPTION_COLLAPSE_THRESHOLD
            }
          />
        </div>
      </ResponsiveWrapper>
      <CardDivider type="section" sectionClassName="lg:hidden" />
      {!isTenant && (
        <>
          <ResponsiveWrapper className="mt-8 px-4 md:px-0">
            <OtherDetail />
          </ResponsiveWrapper>
          <CardDivider type="section" />
        </>
      )}
      <ResponsiveWrapper className="mt-10">
        <OtherProducts productId={productId} vendorId={vendorId} />
      </ResponsiveWrapper>
    </>
  );
};

export default Body;
